/**
 * 재처리 결과 diff 조회 훅.
 *
 * - ``enabled`` 가 false 면 자동 호출되지 않음 (검토 대기 없는 행은 호출하지 않는다).
 * - 캐시 키는 (jobId, fileId) 조합 — 다른 파일과 격리.
 */

import { useQuery } from "@tanstack/react-query";

import { getRecordDiff, type RecordDiffOut } from "@/lib/api/records";

export const recordDiffKey = (jobId: string, fileId: string) =>
  ["records", jobId, fileId, "diff"] as const;

interface Args {
  jobId: string;
  fileId: string;
  enabled?: boolean;
}

export function useRecordDiff({ jobId, fileId, enabled = true }: Args) {
  return useQuery<RecordDiffOut>({
    queryKey: recordDiffKey(jobId, fileId),
    queryFn: () => getRecordDiff(jobId, fileId),
    enabled,
    // diff 는 staging 상태가 바뀔 때만 다시 받으면 충분
    refetchOnWindowFocus: false,
  });
}
